// Erros de borda. ConflictError modela o HTTP 409 JOURNEY_STEP_CONFLICT
// (gate de nível da jornada) — a UI o distingue de erro genérico.
export class ApiError extends Error {
  constructor(public status: number, public code: string | null, message: string) {
    super(message)
    this.name = 'ApiError'
  }
}

export class ConflictError extends ApiError {
  constructor(message = 'Outro operador iniciou esta etapa primeiro.') {
    super(409, 'JOURNEY_STEP_CONFLICT', message)
    this.name = 'ConflictError'
  }
}

// Cancelamento intencional de uma request (AbortController) — ex.: reload() abortando
// uma chamada antiga porque uma mais nova foi disparada. NÃO é uma falha de rede real;
// os callers devem tratá-lo silenciosamente (sem toast de erro).
export class AbortedError extends Error {
  constructor(message = 'Requisição abortada.') {
    super(message)
    this.name = 'AbortedError'
  }
}
